import { atom } from 'recoil';

import { QueryStatus } from 'react-query';

import { EnquiryList } from './enquiry.interface';

export const enquiryListStatusAtom = atom<QueryStatus>({
  key: 'enquryListStatusAtom',
  default: 'idle',
});

export const enquiryListDataAtom = atom<EnquiryList | null>({
  key: 'enquryListDataAtom',
  default: null,
});
